var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCupboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480.807 192.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 240.643,
    y1: 58.896,
    x2: 240.643,
    y2: 195.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006663"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "480.807 67.657 .475 67.657 31.312 53.45 411.159 53.45 480.807 67.657",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.103,67.657v121.201c0,1.833-1.488,3.321-3.321,3.321H11.503c-1.836,0-3.321-1.488-3.321-3.321V67.657H473.103Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 67.421,
    width: 480.332,
    height: 12.071,
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.183,
    y: 79.492,
    width: 464.92,
    height: 5.207,
    fill: "#006663"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 145.115,
    y: 82.451,
    width: 3.321,
    height: 109.588,
    fill: "#006663"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.115,
    y: 84.699,
    width: 0.996,
    height: 107.34,
    fill: "#00b2ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 147.771,
    y: 105.993,
    width: 81.271,
    height: 3.321,
    fill: "#006663"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.552,
    y: 108.317,
    width: 79.06,
    height: 0.996,
    fill: "#00b2ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 147.771,
    y: 133.928,
    width: 81.271,
    height: 3.321,
    fill: "#006663"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.552,
    y: 136.252,
    width: 79.06,
    height: 0.996,
    fill: "#00b2ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 147.771,
    y: 161.863,
    width: 81.271,
    height: 3.321,
    fill: "#006663"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.552,
    y: 164.187,
    width: 79.06,
    height: 0.996,
    fill: "#00b2ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 226.789,
    y: 82.451,
    width: 3.321,
    height: 109.588,
    fill: "#006663"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.788,
    y: 84.699,
    width: 0.996,
    height: 21.293,
    fill: "#00b2ad"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.788,
    y: 108.314,
    width: 0.996,
    height: 25.614,
    fill: "#00b2ad"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.788,
    y: 136.249,
    width: 0.996,
    height: 25.614,
    fill: "#00b2ad"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.788,
    y: 164.19,
    width: 0.996,
    height: 27.85,
    fill: "#00b2ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 308.463,
    y: 82.451,
    width: 3.321,
    height: 109.588,
    fill: "#006663"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.461,
    y: 84.699,
    width: 0.996,
    height: 107.34,
    fill: "#00b2ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 390.136,
    y: 82.451,
    width: 3.321,
    height: 109.588,
    fill: "#006663"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.135,
    y: 84.699,
    width: 0.996,
    height: 107.34,
    fill: "#00b2ad"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "325.862 84.699 235.844 192.179 190.866 192.179 280.885 84.699 325.862 84.699",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.316,84.699L20.297,192.179H11.503c-1.836,0-3.321-1.488-3.321-3.321v-35.918l57.155-68.24h44.978Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.103 84.699 473.103 99.411 395.404 192.179 350.423 192.179 440.442 84.699 473.103 84.699",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.762 84.699 112.743 192.179 100.433 192.179 190.451 84.699 202.762 84.699",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.746 84.699 148.725 192.179 136.417 192.179 226.436 84.699 238.746 84.699",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.346 84.699 334.327 192.179 320.121 192.179 410.139 84.699 424.346 84.699",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.658,
    y: 90.394,
    width: 99.191,
    height: 93.037,
    rx: 3.321,
    ry: 3.321
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Oven"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.33,
    y: 89.066,
    width: 101.847,
    height: 95.694,
    rx: 4.649,
    ry: 4.649
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.658,
    y: 90.394,
    width: 99.191,
    height: 93.037,
    rx: 3.321,
    ry: 3.321,
    fill: "#2e302a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.339,
    y: 119.5,
    width: 87.829,
    height: 57.29,
    rx: 3.321,
    ry: 3.321,
    fill: "#060303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.75,
    y: 92.811,
    width: 44.27,
    height: 13.02,
    rx: 1.993,
    ry: 1.993,
    fill: "#060303"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 39.023,
    cy: 99.039,
    r: 4.317,
    fill: "#060303"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.834,
    cy: 99.039,
    r: 4.317,
    fill: "#060303"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.674,
    cy: 99.039,
    r: 4.317,
    fill: "#060303"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.485,
    cy: 99.039,
    r: 4.317,
    fill: "#060303"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40.402,
    y: 122.819,
    width: 79.701,
    height: 11.593,
    rx: 1.993,
    ry: 1.993,
    fill: "#2e302a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.11,139.387c1.1,0,1.992,.892,1.992,1.992v29.26c0,1.1-.892,1.993-1.992,1.993H42.394c-1.1,0-1.993-.892-1.993-1.993v-29.26c0-1.1,.892-1.992,1.993-1.992H118.11m0-.664H42.394c-1.465,0-2.657,1.192-2.657,2.657v29.26c0,1.465,1.192,2.657,2.657,2.657H118.11c1.465,0,2.657-1.192,2.657-2.657v-29.26c0-1.465-1.192-2.657-2.657-2.657h0Z",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.491,126.791v1.657c0,.345-.053,.681-.153,.993-.422,1.348-1.677,2.328-3.168,2.328H45.333c-1.491,0-2.746-.98-3.168-2.328-.1-.312-.153-.648-.153-.993v-1.657H118.491Z",
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.011,
    y: 124.53,
    width: 5.449,
    height: 5.563,
    rx: 2.725,
    ry: 2.725,
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.044,
    y: 124.53,
    width: 5.449,
    height: 5.563,
    rx: 2.725,
    ry: 2.725,
    fill: "#b0b0b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.339,129.441c-.422,1.348-1.677,2.328-3.168,2.328H45.333c-1.491,0-2.746-.98-3.168-2.328H118.339Z",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 53.404,
    y1: 143.999,
    x2: 106.538,
    y2: 143.999,
    fill: "none",
    stroke: "#afafaf",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.42,
    y1: 149.68,
    x2: 112.522,
    y2: 149.68,
    fill: "none",
    stroke: "#afafaf",
    strokeMiterlimit: 10,
    strokeWidth: 0.664
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.404,
    y1: 155.362,
    x2: 106.538,
    y2: 155.362,
    fill: "none",
    stroke: "#afafaf",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.42,
    y1: 161.043,
    x2: 112.522,
    y2: 161.043,
    fill: "none",
    stroke: "#afafaf",
    strokeMiterlimit: 10,
    strokeWidth: 0.664
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.404,
    y1: 166.725,
    x2: 106.538,
    y2: 166.725,
    fill: "none",
    stroke: "#afafaf",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 30.658,
    y: 107.899,
    width: 99.191,
    height: 1.896,
    fill: "#351b22"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Stove"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M132.332,55.24l-2.348,8.379c-.08,.287-.342,.485-.64,.485H33.248c-.687,0-.922-.916-.32-1.246l15.261-8.379c.098-.054,.208-.082,.32-.082h83.184c.44,0,.758,.42,.64,.843Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.482,62.947l1.343-.731c.164-.089-.251-.161-.926-.161h-24.707c-.675,0-1.355,.072-1.518,.161l-1.343,.731c-.164,.089,.251,.161,.926,.161h24.707c.675,0,1.355-.072,1.518-.161Z",
    fill: "#494c43"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.435,
    cy: 56.588,
    rx: 7.024,
    ry: 0.888,
    fill: "none",
    stroke: "#62665a",
    strokeMiterlimit: 10,
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.655,
    cy: 56.588,
    rx: 7.024,
    ry: 0.888,
    fill: "none",
    stroke: "#62665a",
    strokeMiterlimit: 10,
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.117,
    cy: 59.902,
    rx: 7.024,
    ry: 0.888,
    fill: "none",
    stroke: "#62665a",
    strokeMiterlimit: 10,
    strokeWidth: 0.576
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.731,
    cy: 59.764,
    rx: 7.024,
    ry: 0.888,
    fill: "none",
    stroke: "#62665a",
    strokeMiterlimit: 10,
    strokeWidth: 0.576
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Tap"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.382,53.925h-4.317V17.225c-.062-.979-.372-8.442,4.075-13.253,2.436-2.635,5.774-3.972,9.921-3.972,2.84,0,5.27,1.014,7.224,3.013,5.149,5.27,4.966,15.795,4.956,16.24l-4.316-.1c.054-2.535-.512-9.839-3.733-13.128-1.125-1.149-2.476-1.708-4.131-1.708-2.927,0-5.131,.841-6.738,2.571-3.384,3.644-2.951,10.034-2.947,10.098l.006,.165V53.925Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.964,15.953h0c1.883,0,3.412,1.529,3.412,3.412v.906c0,.367-.298,.664-.664,.664h-5.497c-.367,0-.664-.298-.664-.664v-.906c0-1.883,1.529-3.412,3.412-3.412Z",
    fill: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.304,
    y: 49.584,
    width: 5.918,
    height: 4.32,
    fill: "#a5a5a5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.264,66.096c-.144,0-.288-.024-.429-.071l-25.275-8.733c-.626-.217-.985-.824-.875-1.477,.11-.652,.648-1.107,1.308-1.107h79.657c.089,0,.177,.009,.278,.03l38.739,8.733c.671,.15,1.105,.756,1.029,1.441-.076,.686-.631,1.183-1.321,1.183h-93.11Z",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.374,65.432h-93.11c-.076,0-.149-.013-.219-.037l-25.268-8.731c-.707-.246-.531-1.292,.216-1.292h79.657c.05,0,.096,.007,.146,.017l38.725,8.731c.774,.173,.648,1.312-.146,1.312Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.52,55.373v10.059h-54.256c-.076,0-.149-.013-.219-.037l-25.268-8.731c-.707-.246-.531-1.292,.216-1.292h79.528Z",
    fill: "#a5a5a5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupboard);
export default __webpack_public_path__ + "static/media/cupboard.df75b9c1f2593d9f1b663aaf2ac77e2f.svg";
export { ForwardRef as ReactComponent };